import React from 'react';
type DecorProps = {
  className?: string;
};

/** Octógono Bagua: el mapa que estructura todo el sistema. */
export function Bagua({
  className = ''
}: DecorProps) {
  const octagon = '50,4 82,17 96,50 82,83 50,96 18,83 4,50 18,17';
  return <svg viewBox="0 0 100 100" className={className} aria-hidden="true" data-id="element-34" data-mp="jr9qo7qu16ph">
      <polygon points={octagon} fill="none" stroke="currentColor" strokeWidth="1.1" data-id="element-35" data-mp="ooibyh7a1quy" />
      <polygon points="50,16 74,26 84,50 74,74 50,84 26,74 16,50 26,26" fill="none" stroke="currentColor" strokeWidth="0.7" data-id="element-36" data-mp="3n7ynv34iz42h" />
      <circle cx="50" cy="50" r="13" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-37" data-mp="3s71qyi0y307t" />
      <path d="M50 37a6.5 6.5 0 0 1 0 13 6.5 6.5 0 0 0 0 13 13 13 0 0 0 0-26z" fill="currentColor" opacity="0.55" data-id="element-38" data-mp="yxnxjw9o3et" />
      <g stroke="currentColor" strokeWidth="0.7" data-id="element-39" data-mp="5sa18xvhwns9">
        <path d="M50 4v12M50 84v12M4 50h12M84 50h12M18 17l8.5 8.5M74 74l8.5 8.5M82 17l-8.5 8.5M26 74l-8.5 8.5" data-id="element-40" data-mp="34gz7gqb3j2kt" />
      </g>
    </svg>;
}

/** Brújula Luo Pan, gira muy lentamente como detalle de fondo. */
export function LuoPan({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 120 120" className={className} aria-hidden="true" data-id="element-41" data-mp="2akdxnyll2nue">
      <circle cx="60" cy="60" r="56" fill="none" stroke="currentColor" strokeWidth="1.2" data-id="element-42" data-mp="25jqajo0h6r5g" />
      <circle cx="60" cy="60" r="44" fill="none" stroke="currentColor" strokeWidth="0.8" data-id="element-43" data-mp="20r5ios14qo4k" />
      <circle cx="60" cy="60" r="30" fill="none" stroke="currentColor" strokeWidth="0.8" data-id="element-44" data-mp="1wptrwj6irwus" />
      <circle cx="60" cy="60" r="4" fill="currentColor" data-id="element-45" data-mp="1rs1x9hehpwmw" />
      {Array.from({
      length: 24
    }, (_, index) => {
      const angle = index * 15 * Math.PI / 180;
      const inner = index % 2 === 0 ? 44 : 50;
      return <line key={index} x1={60 + Math.cos(angle) * inner} y1={60 + Math.sin(angle) * inner} x2={60 + Math.cos(angle) * 56} y2={60 + Math.sin(angle) * 56} stroke="currentColor" strokeWidth="0.8" data-id="element-46" data-mp="1hudsrzr31arj" />;
    })}
      <path d="M60 22l6 34-6 8-6-8z" fill="currentColor" opacity="0.5" data-id="element-47" data-mp="3c73magdjghye" />
    </svg>;
}

/** Caña de bambú: elemento Madera. */
export function Bamboo({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 60 160" className={className} aria-hidden="true" data-id="element-48" data-mp="15il517c2ecwm">
      <g stroke="currentColor" strokeWidth="2" fill="none" data-id="element-49" data-mp="1aamr1kz1bhzu">
        <path d="M26 158V6" data-id="element-50" data-mp="1ac62my9qx4va" />
        <path d="M14 34h24M14 68h24M14 102h24M14 136h24" strokeWidth="1.6" data-id="element-51" data-mp="wj85p7hnn4pm" />
      </g>
      <path d="M27 44c12-6 24-4 30 2-10 8-22 9-30 2z" fill="currentColor" opacity="0.4" data-id="element-52" data-mp="10k9wr11f4agi" />
      <path d="M25 84c-12-6-22-4-25 2 9 8 19 8 25 2z" fill="currentColor" opacity="0.35" data-id="element-53" data-mp="10hxioyys6k8q" />
      <path d="M27 112c11-7 22-6 28 0-9 8-21 9-28 3z" fill="currentColor" opacity="0.3" data-id="element-54" data-mp="1o81iswcrg1uz" />
    </svg>;
}

/** Hojas de planta interior, elemento Madera en versión decorativa. */
export function LeafSpray({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 120 120" className={className} aria-hidden="true" data-id="element-55" data-mp="1k7hnlybqz8bh">
      <g fill="currentColor" opacity="0.5" data-id="element-56" data-mp="3u0yzl81r8ta">
        <path d="M60 116c0-30 10-52 34-66-6 30-14 50-34 66z" data-id="element-57" data-mp="3t7z947i9jkn" />
        <path d="M60 116c0-30-10-52-34-66 6 30 14 50 34 66z" data-id="element-58" data-mp="8su7t0ce2bn4" />
        <path d="M60 116c6-26 22-42 46-46-14 24-28 38-46 46z" opacity="0.7" data-id="element-59" data-mp="8r11jm5ottfn" />
        <path d="M60 116c-6-26-22-42-46-46 14 24 28 38 46 46z" opacity="0.7" data-id="element-60" data-mp="aijw5oa08di" />
      </g>
      <path d="M60 118V60" stroke="currentColor" strokeWidth="1.4" fill="none" data-id="element-61" data-mp="3sf4badhmki95" />
    </svg>;
}

/** Ondas de agua: elemento Agua. */
export function WaterRipple({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 200 40" className={className} aria-hidden="true" data-id="element-62" data-mp="5chotjznzdck">
      <g fill="none" stroke="currentColor" strokeWidth="1.4" data-id="element-63" data-mp="3dqgkslmmyyq2">
        <path d="M0 10q12.5-10 25 0T50 10t25 0 25 0 25 0 25 0 25 0" data-id="element-64" data-mp="3dowz2fi7nvgw" />
        <path d="M0 22q12.5-10 25 0T50 22t25 0 25 0 25 0 25 0 25 0" opacity="0.7" data-id="element-65" data-mp="38thr246vwtse" />
        <path d="M0 34q12.5-10 25 0T50 34t25 0 25 0 25 0 25 0 25 0" opacity="0.45" data-id="element-66" data-mp="3nhunt3dsqgny" />
      </g>
    </svg>;
}

/** Moneda china: elemento Metal, sello de prosperidad. */
export function Coin({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 64 64" className={className} aria-hidden="true" data-id="element-67" data-mp="2uynrsr7khdic">
      <circle cx="32" cy="32" r="28" fill="none" stroke="currentColor" strokeWidth="2.4" data-id="element-68" data-mp="2q0dx0hpr8ex9" />
      <circle cx="32" cy="32" r="22" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-69" data-mp="1tatltv5ra46w" />
      <rect x="23" y="23" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.4" data-id="element-70" data-mp="1y8lit3l9cghy" />
      <path d="M32 10v13M32 41v13M10 32h13M41 32h13" stroke="currentColor" strokeWidth="1.2" data-id="element-71" data-mp="22agkwab0ixws" />
    </svg>;
}

/** Nubes orientales para franjas de fondo. */
export function Clouds({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 240 60" className={className} aria-hidden="true" data-id="element-72" data-mp="2bzqczq5uwgkw">
      <g fill="none" stroke="currentColor" strokeWidth="1.4" data-id="element-73" data-mp="2gz39l2mj520o">
        <path d="M10 44c0-10 8-14 14-10 2-10 14-12 18-4 6-6 16-2 16 8 8 0 10 8 6 12" data-id="element-74" data-mp="2h1frxgw79ee9" />
        <path d="M96 40c0-9 7-13 13-9 2-9 13-11 16-4 6-5 15-2 15 8 7 0 9 7 5 11" data-id="element-75" data-mp="2lzhck699xlru" />
        <path d="M178 46c0-10 8-14 14-10 2-10 13-12 17-4 6-6 15-2 15 8 7 0 9 8 5 12" data-id="element-76" data-mp="2pzrf18xuxu1y" />
      </g>
    </svg>;
}